import React from 'react'
import { connect } from 'react-redux'
import { defineMessages, FormattedMessage } from 'react-intl'
import { selectNewInvestmentBudget } from 'src/store/selectors/home/equity'
import {
  Heading,
  ProConList,
  Pro,
  Info
} from 'src/Components/shared/Gem/GemDetail'

const ExploreInvestments = props => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.exploreInvestmentsHeading'
        defaultMessage='While using home equity for alternative investments isn’t tax-deductible, it still might make sense for your specific goals. Chatting with your lender will help you understand your options!'
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.exploreInvestmentsOne'
          defaultMessage='How can you secure your equity in the event of a market downturn?'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.exploreInvestmentsTwo'
          defaultMessage='Understand how equity might be used to fund college or retirement'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.exploreInvestmentsThree'
          defaultMessage='Jump start a new business venture and be your own boss'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.exploreInvestmentsFour'
          defaultMessage='Always talk to a financial expert for professional advice on investing'
        />
      </Info>
    </ProConList>
  </div>
)

export default {
  GemContainer: connect(state => ({
    qaTag: 'exploreInvestmentsGem',
    amount: selectNewInvestmentBudget(state)
  })),
  Detail: ExploreInvestments,
  ...defineMessages({
    question: {
      id: 'Homeowner.equity.exploreInvestmentsQuestion',
      defaultMessage: 'Can we chat through my goals?'
    },
    topic: {
      id: 'Homeowner.equity.exploreInvestmentsTopic',
      defaultMessage: 'exploring new investments'
    }
  })
}
